import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DragDropModule} from '@angular/cdk/drag-drop';

// import { AgmCoreModule } from '@agm/core';
// import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
// import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';

import { Ng2GoogleChartsModule} from 'ng2-google-charts';

import { GoogleChartsModule } from 'angular-google-charts';
import { MdePopoverModule } from '@material-extended/mde';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { GridsterModule } from 'angular-gridster2';
import { ToolTipRendererDirective } from './tool-tip-renderer.directive';
import { GaugeModule } from 'angular-gauge';
import * as moment from 'moment';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatBadgeModule
} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { CardsComponent, DialogOverviewExampleDialog, DialogOverviewConfirm, CreateEditSpace, ViewEditAlarmsDialog } from './cards/cards.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule, AngularFireDatabase } from '@angular/fire/database';
import { LoginComponent } from './login/login.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AlarmsComponent } from './alarms/alarms.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { IndicesComponent } from './indices/indices.component';
import { HistoryComponent } from './history/history.component';
import { CustomToolTipComponent } from './custom-tool-tip/custom-tool-tip.component';
import { EficiencyComponent, OverviewCharts } from './eficiency/eficiency.component';
import { ControlsComponent, ConfigDialog } from './controls/controls.component';
import { ComparativesComponent } from './comparatives/comparatives.component';
import { DeuComponent } from './deu/deu.component';
import { ResumeComponent } from './resume/resume.component';
import { DatainputComponent, NewEditData, ConfirmDialog } from './datainput/datainput.component';
import { PlanillasComponent } from './planillas/planillas.component';


//...
//const weekdaysMin = moment.weekdaysMin();
const weekdaysMin = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const monthsShort = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CardsComponent,
    LoginComponent,
    AlarmsComponent,
    NotFoundComponent,
    DialogOverviewExampleDialog,
    DialogOverviewConfirm,
    OverviewCharts,
    IndicesComponent,
    HistoryComponent,
    CustomToolTipComponent,
    ToolTipRendererDirective,
    EficiencyComponent,
    ControlsComponent,
    ConfigDialog,
    CreateEditSpace,
    ComparativesComponent,
    DeuComponent,
    ResumeComponent,
    DatainputComponent,
    NewEditData,
    ConfirmDialog,
    ViewEditAlarmsDialog,
    PlanillasComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    //material
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatBadgeModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    MdePopoverModule,
    //maps

    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyAKvRn3MOdZY-FeQuSWcBWzLSg-kgnBm-c',
    //   libraries: ["places"]
    // }),
    // AgmSnazzyInfoWindowModule,
    // AgmJsMarkerClustererModule,

    //google charts
    Ng2GoogleChartsModule,
    //GoogleChartsModule,

    //Drag & Drop
    DragDropModule,

    //gridster
    GridsterModule,

    //date picker range
    NgxDaterangepickerMd.forRoot({
    //daysOfWeek: moment.weekdaysMin(),
    daysOfWeek: weekdaysMin,
    //monthNames: moment.monthsShort(),
    monthNames: monthsShort,
      }),

    //angular gauge
    GaugeModule.forRoot(),
    //PDF Viewer
    PdfViewerModule
  ],
  providers: [AngularFireAuth, AngularFirestore, AngularFireDatabase],
  bootstrap: [AppComponent],
  entryComponents: [DialogOverviewExampleDialog, CustomToolTipComponent, DialogOverviewConfirm, OverviewCharts, ConfigDialog, CreateEditSpace, NewEditData, ConfirmDialog, ViewEditAlarmsDialog]
})
export class AppModule { }
